export default function (amount, currency = null) {
    currency = currency ?? 'RM';

    return `${currency}${typeof amount === 'string' ? amount : amount.toLocaleString()}`;
}
